<template>
<!--  <div id="app">
    <div v-if="$route.path!='/login'">
      <headers/>
      <div class="pageBox pageWarp">
          <left style="height: 100%;" />
          <router-view class="main"/>
      </div>
    </div>
    <div v-if="$route.path=='/login'">
        <router-view/>
    </div>
  </div> -->
 <div id="app">
   <navHeader />
	 <el-container v-if="$route.path!='/login'" class="wraper">
	   <el-aside width="220px" style="overflow-y: auto;overflow-x: hidden;box-shadow: 3px 0px 6px 1px rgba(0,0,0,0.2);"><left/></el-aside>
	   <el-container class="app_wraper">
	     <!-- <el-header><headers/></el-header> -->
       <!-- <tags-view v-if="needTagsView" /> -->
	     <el-main style="overflow: hidden;width: 100% !important;padding:10px 16px ">
        <!-- <transition name="fade-transform" mode="out-in">
          <keep-alive :include="cachedViews">
            <router-view :key="key" class="main"/>
          </keep-alive>
        </transition> -->
       <router-view class="main"/>
      </el-main>
	   </el-container>
	 </el-container>
	 <div v-if="$route.path=='/login'">
	     <router-view/>
	 </div>
 </div>
</template>

<script>
import TagsView  from './components/TagsView'
import navHeader from '@/components/Header'
import headers from './components/headers';
import left from './components/left';
export default {
  components:{
    headers,
    left,
    navHeader,
    TagsView
  },
  computed: {
    needTagsView() {
      return this.$store.state.settings.tagsView
    },
    cachedViews() {
      console.log('tags---',this.$store.state.tagsView.cachedViews)
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
#app{
	height: 100%;
  overflow: hidden;
}
.el-header{
	padding: 0;
}

.el-aside::-webkit-scrollbar {
  width: 4px;
}
.el-aside::-webkit-scrollbar-thumb {
  background-color: #bdbdbd;
  border-radius: 2px;
}
.el-aside::-webkit-scrollbar {
  width: 4px;
}
.el-main::-webkit-scrollbar-track {
  background-color: transparent;
}
.el-main::-webkit-scrollbar-thumb {
  background-color: #bdbdbd;
  border-radius: 2px;
}
.el-main::-webkit-scrollbar-track {
  background-color: transparent;
}
// .pageBox{
//   display: flex;
//   height: 100%;
//   .main{
//     min-width: 940px;
//     flex: 1;
//     margin: 10px 0 0 10px;
//     background:rgba(255,255,255,1);
//     box-shadow:3px 3px 8px rgba(0,0,0,0.03);
//     position: relative;
//     padding: 20px;
//   }
// }

section.el-container {
  overflow: hidden;
  // height: calc(100% - 64px);
}
.wraper{
  height:calc(100% - 64px);
}
.app_wraper{
  height:100% !important;
  display: flex;
  flex-direction: column;
}

</style>